import React, { useState } from "react";
import rocket_pro from "@images/rocket_pro.svg";
import arrow_drop_down from "@images/arrow_drop_down.svg";
import pro from "@images/pro.svg";
import Description from "./Description";

const features_paid = [
  I18n.t("plans.pro.bullet1"),
  I18n.t("plans.pro.bullet2"),
  I18n.t("plans.pro.bullet3"),
  I18n.t("plans.pro.bullet4"),
  I18n.t("plans.pro.bullet5"),
  I18n.t("plans.pro.bullet6"),
  I18n.t("plans.pro.bullet7"),
];

const Pro = ({ activeTab, rateData }) => {
  const [showDetails, setShowDetails] = useState(false);

  const tariffs = rateData.filter((t) => t.key === "pro");

  let activeRate = null;
  for (const tariff of tariffs) {
    activeRate = tariff.rate_data.find((r) => r.key === activeTab);
    if (activeRate) break;
  }

  if (!activeRate) {
    console.error("Active rate not found for tab:", activeTab);
    return null;
  }

  let period = I18n.t("plans.per_" + activeTab);

  return (
    <div
      className="pro-block mb-20"
      onClick={() => setShowDetails(!showDetails)}
    >
      <div className="price-header">
        <img
          className="price-header__img"
          width="48"
          height="48"
          src={rocket_pro}
          alt="rocket"
        />
        <div className="price-header__txt pro">
          <img
            className="pro__name"
            src={pro}
            width="62"
            height="30"
            alt="pro"
          />
          <p className="pro__price">{activeRate.price + " ₽ / " + period}</p>
          <p className="pro__details">{activeRate.details}</p>
        </div>
        <img
          className="price-header__arrow_drop_down"
          width="9"
          height="7"
          src={arrow_drop_down}
          alt="arrow_drop_down"
        />
      </div>

      <Description
        showDetails={showDetails}
        activeTab={activeTab}
        features={features_paid}
        paidPro={true}
      />
    </div>
  );
};

export default Pro;
